export { default } from './TableOfContent.jsx'
